<template>
  <div>
    <div class="flex mb-4" style="align-items: center;">
      <h5>합동점검일지</h5>
      <vs-spacer></vs-spacer>
      <vs-button color="secondary" @click="showApproval">결재 프로세스</vs-button>
    </div>
    <div style="margin-left:-1.2rem; margin-right:-1.2rem; padding:1.2rem; background: #fff;">
      <div class="flex mb-8" >
        <vs-button class="w-1/2 mr-2" color="secondary" type="border" @click="back">닫기</vs-button>
        <vs-button class="w-1/2 ml-2" color="secondary" @click="handleClickUpdate">임시저장</vs-button>
        <vs-button v-if="board.resend" class="" color="secondary" @click="handleClickRegister">임시저장 후 재상신</vs-button>
      </div>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>기본정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 mr-2 flex" vs-align="center">
          <vs-col class="w-3/12 title">제목</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.title"/></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4 ">사무소명</vs-col>
          <vs-col class="w-9/12"><vs-input class="w-full" v-model="form.project_title" :readonly="true" /></vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title pr-4">점검일</vs-col>
          <vs-col class="w-9/12"><date-selector class="w-full" v-model="form.checkDate"/> </vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="mb-4">
        <vs-col><h5><i class="dot"></i>점검 인원 정보</h5></vs-col>
      </vs-row>

      <vs-row class="mb-4 flex flex-wrap" >
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title">시공사 </vs-col>
          <vs-col class="w-9/12">
            <vs-select autocomplete class="w-full" v-model="form.member1">
              <vs-select-item v-for="(item) in members" :key="item.id" :value="item.id" :text="item.name"/>
            </vs-select>
          </vs-col>
        </vs-row>
        <vs-row class="w-full px-4 mb-4 flex" vs-align="center">
          <vs-col class="w-3/12 title ">소속</vs-col>
          <vs-col class="w-9/12">
            <vs-select autocomplete class="w-full" v-model="form.member2">
              <vs-select-item v-for="item in members" :key="item.id" :value="item.id" :text="item.name"/>
            </vs-select>
          </vs-col>
        </vs-row>
      </vs-row>

      <vs-row class="pb-4 border-bottom">
        <vs-col class="flex mb-4">
          <h5><i class="dot"></i>점검내용</h5>
          <vs-spacer></vs-spacer>
          <a @click="handleClickAddEval" style="color:#6670CB;">+ 항목추가</a>
        </vs-col>
      </vs-row>
      <vs-row class="mb-8">
        <vs-col v-for="(item, index) in form.pointoutList" :key="index"
                class="pointout p-3 border-bottom"
        >
          <p class="flex mb-2" style="align-items: center;">
            <vs-spacer></vs-spacer>
            <a href="javascript:;" @click="()=>{clickRemoveEval(item)}">삭제</a>
          </p>
          <p class="flex mb-2" style="align-items: center;">
            <span class="w-3/12">지적사항</span>
            <span class="w-9/12"><vs-input class="w-full" v-model="item.text1"/></span>
          </p>
          <p class="flex mb-2" style="align-items: center;">
            <span class="w-3/12">소속</span>
            <span class="w-9/12"><vs-input class="w-full" v-model="item.text2"/></span>
          </p>
          <p class="flex mb-2" style="align-items: center;">
            <span class="w-3/12">조치기일</span>
            <span class="w-9/12"><date-selector class="w-full" v-model="item.date"/></span>
          </p>
        </vs-col>
      </vs-row>

      <vs-row :class="isShowApproval?'':'hidden'" style="position:fixed; top:0; left:0; bottom:0; right:0; z-index:45000; background: rgba(0,0,0,0.7); ">
        <div style="position: relative; width: 100%; height:100%; display: grid; grid-template-rows: 110px; minmax(0%,100%); overflow-y: auto;">
          <vs-spacer @click="hideApproval"></vs-spacer>
          <approval-process-module
            :board = "board"
            :commentabled="!(board.isCompleteApproval || board.savable)"

            @handleClickUpload="handleClickUpload"
            @handleClickOk="handleClickOk"
            @handleClickNo="handleClickNo"
            @handleSendApprovalProcess = "handleSendApprovalProcess"
          ></approval-process-module>
          <a style="width:33px; height:33px; position:absolute; top:77px; right:10px;"  @click="hideApproval">
            <i class="vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null" style="background: rgb(255, 255, 255);">close</i>
          </a>
        </div>

      </vs-row>

      <vs-row>
        <vs-col class="">
          <h5 class="mb-4"><i class="dot"></i>현장점검내용(이슈사항, 합동점검,특별작업 등)</h5>
        </vs-col>
      </vs-row>
      <vs-row class="mb-4">
        <vs-col>
          <vs-textarea
            class="w-full"
            rows="5"
            v-model="form.comment2"
          />
        </vs-col>
      </vs-row>

      <file-upload-module class="w-full" :isShowTitle="true" type="check_list_col" id="bottom" v-model="fileList"/>

      <!-- TODO : 얼럿데이터 -->
      <popup-alert v-model="alert.show"
                   :is-confirm="alert.isConfirm"
                   :html="alert.html"
                   :message="alert.message"
                   :buttons="alert.buttons"

                   @upload="alertUpload"
                   @ok="alertOk"
                   @no="alertNo"
      ></popup-alert>
    </div>
  </div>
</template>

<script>
import ApprovalProcessModule from '@/views/modules/ApprovalProcessModule'
import DateSelector from '@/views/components/DateSelector'
import FileUploadModule from '@/views/modules/FileUploadModule'
import PopupAlert from '@/views/components/popup/PopupAlert'

export default {
  name: 'MobileSafetyDailyCheckLogAllUpdate',
  components: {
    PopupAlert,
    FileUploadModule,
    DateSelector,
    ApprovalProcessModule
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    }
  },
  data () {
    return {
      boardSlug: 'joint_check_diary',
      selectItem:{},

      // TODO : 글쓰기 정보 및 권한
      board:{
        slug:'joint_check_diary',
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        resend: false, // 재등록 가능한가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine:[], // 결재라인
        commentList:[] // 댓글리스트
      },

      // TODO : 얼럿데이터
      alert:{
        show:false,
        message:'결재하시겠습니까?',
        buttons:[
          { label:'승인', action:'ok' },
          { label:'취소', action:'cancel' }
        ]
      },
      approvalLine:[], // 결재선 등록
      isShowApproval:false,

      members:[],
      form:{
        title:'', //제목
        project_title:'', //사무소명
        checkDate:'', //점검일
        member1:'', //시공사
        member2:'', //파트너사

        pointoutList:[], // 지적사항
        comment2:'', // 현장점검내용(이슈사항, 합동점검,특별작업 등)

        // preview
        preview: {
          title: '',
          project_title:'',
          checkDate:'',
          writer:''
        }
      },
      fileList:[] //파일리스트
    }
  },

  mounted () {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {

      if (JSON.stringify(this.oldForm) === JSON.stringify(this.form)) {
        next(true)
      } else if (confirm('저장하지 않은 데이터는 삭제됩니다. 닫으시겠습니까?')) {
        next(true)
      }

    })
    this.$once('hook:destroyed', () => {
      backButtonRouteGuard()
    })
  },


  async created () {

    const page = 1
    const perPage = 10000
    const keyword = ''
    await this.$store.dispatch('member/LOAD_MEMBERS', {page, perPage, keyword})
    this.members = this.$store.state.member.list

    // 초기화
    await this.loadPost()
  },

  methods:{

    back () {
      this.$router.back()
    },

    async loadPost () {
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId

      await this.$store.dispatch('approval/LOAD_POST', {boardSlug, postId})

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post
      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id:file.id,
            fileName:file.file_name,
            fileSize:file.file_size,
            path:file.path,
            thumb:file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !((this.board.isWriter && (this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')) || this.board.isTurnApproval)
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
      this.approvalLine = doc.line.slice() // api 전송용

      this.oldForm = JSON.parse(JSON.stringify(this.form))
    },

    async register (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const postId = this.$route.params.postId
      const title = this.form.project_title
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      this.form.preview.title = this.form.title
      this.form.preview.project_title = this.form.project_title
      this.form.preview.checkDate = this.form.checkDate
      this.form.preview.writer = this.form.writer
      const content = JSON.stringify(this.form)

      try {
        if (isUploaded) {
          // 바로 상신하기
          const unTemp = 'y'
          await this.$store.dispatch('approval/UPDATE_POST', {projectId, boardSlug, postId, title, content, approvalLine, uploads, unTemp})
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        } else {
          // 임시 저장하기
          const unTemp = 'n'
          await this.$store.dispatch('approval/UPDATE_POST', {projectId, boardSlug, postId, title, content, approvalLine, uploads, unTemp})
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }

    },
    async reRegister (isUploaded) {
      if (isUploaded && (!this.approvalLine || this.approvalLine.length === 0)) {
        alert('결재선을 지정해주세요')
        return
      }

      // 등록정보
      const projectId = this.$route.params.proj_id
      const boardSlug = this.boardSlug
      const title = this.form.project_title
      const approvalLine = JSON.stringify(this.lineToSendLine(this.approvalLine))
      const security = 'normal' // 문서보안 등급 ['일반', 대외비 1급, 대외비 2급, 인비, 극비] [normal,confidential1,confidential2,personally,confidential0]
      const priority = 'medium' // 문서 중요도 [매우낮음, 낮음, 보통, 높음, 매우 높음] [lowest,low,medium,high,highest]

      let uploads = ''
      const listUploads = []
      const uploadFileIds = []

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file)
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      this.form.preview.title = this.form.title
      this.form.preview.project_title = this.form.project_title
      this.form.preview.checkDate = this.form.checkDate
      this.form.preview.writer = this.form.writer
      const content = JSON.stringify(this.form)

      try {
        if (isUploaded) {
          // 바로 상신하기
          await this.$store.dispatch('approval/CREATE_POST', {projectId, boardSlug, title, content, approvalLine, security, priority, uploads})
          alert('상신되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        } else {
          // 임시 저장하기
          const isTemp = 1
          await this.$store.dispatch('approval/CREATE_POST', {projectId, boardSlug, title, content, approvalLine, security, priority, uploads, isTemp})
          alert('임시저장되었습니다.')
          this.oldForm = JSON.parse(JSON.stringify(this.form))
          this.back()
        }

      } catch (e) {
        if (this.$store.state.approval.error_data.title) {
          alert('사무소명이 없습니다')
        } else {
          console.log(this.$store.state.approval.error_code)
        }
      }

    },
    handleClickAddEval () {

      this.form.pointoutList.push({
        is_checked: false,
        text1:'',
        text2:'',
        date:''
      })
    },
    handleClickRemoveEval () {
      for (let i = 0; i < this.form.pointoutList.length; i++) {
        if (this.form.pointoutList[i].is_checked) {
          this.form.pointoutList.remove(this.form.pointoutList[i])
          i = -1
        }
      }
    },
    clickRemoveEval (item) {
      this.form.pointoutList.remove(item)
    },

    handleBackMenu () {
      this.$emit('handleBackMenu', 'checklogall')
    },

    showPopupUploadImages () {
      this.popupUploadImage = true
    },

    handleClickFileUpload () {
      this.popupUploadImage = true
    },

    handleClose () {
      this.selectItem = {}
    },

    // TODO : 얼럿데이터
    async alertOk () {

      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {
        postId
      })

      this.oldForm = JSON.parse(JSON.stringify(this.form))
      document.location.reload()
    },

    async alertNo (text) {
      const postId = this.$route.params.postId
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', {
        postId,
        comment
      })
      document.location.reload()
    },

    alertUpload () {
      this.register(true)
    },

    // TODO : 결재프로세스
    // ApprovalProcessModule 에서 사용하는 line 방식에서 전송용 line 으로 변경
    lineToSendLine (data) {
      const approvalList = []

      for (const member of data) {
        if (member.type_code !== 'register') {
          approvalList.push({
            id : member.user_id,
            name : member.user_name,
            elementType : member.type_code
          })
        }
      }

      return approvalList
    },


    handleClickUpdate () {
      if (confirm('저장하시겠습니까?')) {
        this.register(false)
      }
    },

    handleClickRegister () {
      if (confirm('임시저장 하시겠습니까?')) {
        this.reRegister(false)
      }
    },

    handleClickUpload () {
      this.alert.buttons = [
        { label:'상신', action:'upload' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true

    },
    handleClickNo () {
      this.alert.html = '<p>반려하시겠습니까?</p><p>아래에 사유를 작성해주세요.</p>'
      this.alert.message = ''
      this.alert.isConfirm = true
      this.alert.buttons = [
        { label:'반려', action:'no' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true
    },
    async handleClickOk () {
      this.alert.html = ''
      this.alert.message = '승인하시겠습니까?'
      this.alert.isConfirm = false
      this.alert.buttons = [
        { label:'승인', action:'ok' },
        { label:'취소', action:'cancel', type:'border' }
      ]
      this.alert.show = true

    },

    handleSendApprovalProcess (process) {
      this.approvalLine = process
    },

    showApproval () {
      this.isShowApproval = true
    },

    hideApproval () {
      this.isShowApproval = false
    }
  }
}
</script>

<style scoped>
.pointout:nth-child(2n+1) {
  background: #fafafa;
}
</style>
